import * as Immutable from "immutable";
import transformInaccessibleFilters from "search-filter/logic/transformInaccessibleFilters";
import createSearch from "views/logic/slices/createSearch";
const transformInaccessibleFiltersInSearchTypes = (queries, isPermitted) => queries.map((query) => {
  const updatedSearchTypes = query.searchTypes.map((searchType) => ({
    ...searchType,
    filters: transformInaccessibleFilters(Immutable.List(searchType.filters), isPermitted).toArray()
  }));
  return query.toBuilder().searchTypes(updatedSearchTypes).build();
});
const transformInaccessibleFiltersInWidgets = (viewStates, isPermitted) => viewStates.map((viewState) => {
  const updatedWidgets = viewState.widgets.map((widget) => {
    const updatedFilters = transformInaccessibleFilters(widget.filters, isPermitted);
    return widget.toBuilder().filters(Immutable.List(updatedFilters)).build();
  });
  return viewState.toBuilder().widgets(updatedWidgets.toList()).build();
});
const transformInaccessibleFiltersInDashboard = async (view, isPermitted) => {
  const updatedQueries = transformInaccessibleFiltersInSearchTypes(view.search.queries, isPermitted);
  const newViewState = transformInaccessibleFiltersInWidgets(view.state, isPermitted);
  const newSearchWithNewId = await createSearch(view.search.toBuilder().queries(updatedQueries.toSet()).build());
  return view.toBuilder().search(newSearchWithNewId).state(newViewState.toMap()).build();
};
export default transformInaccessibleFiltersInDashboard;
